import ReactComponent from '../../app/ReactComponent'
import {Button, Drawer, Image, Space} from 'antd'
import { BellOutlined } from '@ant-design/icons'
import React from 'react'
import {Link} from 'react-router-dom'
import {ReactComponent as Logo} from '../../image/logo-desktop.svg'
import MenuSvg from '../../image/Menu.svg'
import LogoPortalDarce from '../../image/logo-portal-darce.svg'
import {ProfileWidget} from './ProfileWidget'
import {NotificationSidenav} from '../notifications/NotificationSidenav'

const closeIcon = <Image preview={false} src={require('../../image/Close@2x.png')} />

export class Menu extends ReactComponent {

  state = {
    current: 'mail',
    visible : false,
    notificationVisible: false,
    account: {},
    isMandatoryDataRequired: false
  }

  componentDidMount = async () => {

    this.unsubscribeAccount = this.$app.$onMemoryChange('personal-information', () => void this.loadAccount())

    await this.loadAccount()

  }

  componentWillUnmount() {
    this.unsubscribeAccount?.()
  }

  loadAccount = async () => {

    const account_store = this.$app.$store('account')

    // Reads the already refreshed cache, no extra request is made
    await this.updateState({
      account: await account_store.getPersonalInfo(),
      isMandatoryDataRequired: await account_store.isMandatoryDataRequired()
    })

  }

  handleLogout = () => {
    this.props.$auth.logout()
    this.close()
  }

  open = () => {
    void this.updateState({visible:true})
  }

  close = () => {

    this.scrollToTop()

    void this.updateState({visible:false});

  }

  openNotifications = () => {
    void this.updateState({notificationVisible:true})
  }

  closeNotifications = () => {
    this.scrollToTop()
    void this.updateState({notificationVisible:false});
  }

  handleClick = e => {

    void this.updateState({ current: e.key })

  }

  render() {
    const menuLogo = <Link to={"/"} onClick={this.close}><Logo/></Link>
    const { current, isMandatoryDataRequired } = this.state
    return (
        <Space>
          {!isMandatoryDataRequired && <Button type="button" onClick={this.openNotifications} className="notification-bell _secondary-text" size={"large"} icon={<BellOutlined style={{fontWeight: 600}}/>} />}
          <Button type="button" onClick={this.open} className="hamburger-menu">
            <span className="menu-text">Menu</span>
            <Image className="menu-icon" preview={false} src={MenuSvg} />
          </Button>
          <Drawer className="menu-drawer" onClick={this.handleClick} title={menuLogo} placement="right" onClose={this.close} open={this.state.visible} closeIcon={closeIcon}>
            <div style={{display:'flex', flexDirection:"column"}}>

              {!isMandatoryDataRequired &&
                <>
                  <Link to="/" onClick={this.close}><Button type="text">Domů</Button></Link>
                  <Link to="/reservation" onClick={this.close}><Button type="text">Rezervace odběru</Button></Link>
                  <Link to="/reservations" onClick={this.close}><Button type="text">Přehled rezervací</Button></Link>
                  <Link to="/health" onClick={this.close}><Button type="text">Zdravotní stav</Button></Link>
                  <Link to="/rewards" onClick={this.close}><Button type="text">Amber Klub</Button></Link>
                </>

              }

              <Link to="/" onClick={() => this.handleLogout()}><Button type="text">Odhlásit</Button></Link>

              {
                !isMandatoryDataRequired &&

                <Link to="/profile" onClick={this.close}>
                  <ProfileWidget
                    gender={this.state.account?.gender}
                    title={[this.state.account?.first_name, this.state.account?.last_name].filter(Boolean).join(' ')}
                    email={this.state.account?.email}/>
                </Link>

              }

            </div>
            <div className="menu-moje-amber-image">
              <Image preview={false} src={LogoPortalDarce}></Image>
            </div>
          </Drawer>
          <NotificationSidenav visible={this.state.notificationVisible} onClose={this.closeNotifications} />
        </Space>
    )
  }
}